import React, { useState, useCallback, useEffect } from 'react';
import { Box, Avatar, Anchor } from 'grommet';
import { User } from 'grommet-icons';
import FileUpload from '@helpers/FileUpload';

const PlayerAvatar: React.FC<{
  updateValues: (values: Record<string, unknown>) => void;
  uploadPlayerImage: (file: File) => Promise<string>;
  defaultImage?: string | null;
}> = ({ updateValues, uploadPlayerImage, defaultImage }) => {
  const [avatarImage, setAvatarImage] = useState<string | null>(
    defaultImage || null
  );

  useEffect(() => {
    if (defaultImage) {
      setAvatarImage(defaultImage);
    }
  }, [defaultImage]);

  const [uploadError, setUploadError] = useState<string | undefined>();

  const handleFile = useCallback(
    async (imageFile: File, imageError: string) => {
      if (imageError) {
        setUploadError(imageError);
        window.scrollTo(0, 0);
        return false;
      }
      setUploadError(undefined);
      if (imageFile) {
        const playerimage = await uploadPlayerImage(imageFile);
        setAvatarImage(playerimage);
        updateValues({
          imageUrlLarge: playerimage,
          imageUrlSmall: playerimage,
        });
      }
    },
    [uploadPlayerImage, updateValues]
  );

  return (
    <Box
      direction="row"
      align="center"
      gap="small"
      justify="start"
      height={{ min: 'small' }}
    >
      {avatarImage ? (
        <Avatar src={avatarImage} size="large" />
      ) : (
        <Avatar background="dark-1" size="large">
          <User color="white" size="large" />
        </Avatar>
      )}
      <FileUpload handleFile={handleFile}>
        <Anchor label={`${avatarImage ? 'Change' : 'Add'} profile picture`} />
      </FileUpload>
      {uploadError && (
        <Box pad="small" background="status-critical">
          {uploadError}
        </Box>
      )}
    </Box>
  );
};

export default PlayerAvatar;
